module.exports = __webpack_public_path__ + "static/img/8.4606ead.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/eng/8.png
// module id = Ib6s
// module chunks = 0